import Component from "../../../../js/assets/component.js"

class DepartureCalendar extends Component{
  constructor(selector) {
    // set root element
    super(selector)
  }

  data() {
    return {
      "activeIndex": 1
    }
  }

  changed() {
    return {
      "activeIndex": (val, prev) => {
        this.changeMonth(val, prev)
      }
    }
  }

  changeMonth(index, prev) {
    for(let i=0; i<this.contentList.length; i++){
      if(i===index){
        this.contentList[i].removeClass("-inactive")
        this.contentList[i].addClass("-active")
      }else{
        this.contentList[i].removeClass("-active")
        this.contentList[i].addClass("-inactive")
      }
    }
  }

  // 選択した出発日を、表示用フォームおよびPOST用フォームに記入
  setDateToForm(year, month, date) {
    const inputFormToHuman = this.el.querySelector(".departureCalendar_selectedDepartureDate")
    const hiddenForm = this.el.querySelector("#departure_date")
    inputFormToHuman.value = `${year}年${month}月${date}日`
    hiddenForm.value = `${year}/${month}/${date}`
  }

  // 出発日カレンダーにて日付を選択したときの処理。
  // アニメーションを起こし、完了後フォームに日付を記入する。
  async selectDepartureDate(event) {

    const $from = $(event.currentTarget)
    const $to = $('#departureCalendar_selectedDepartureDate-toHuman').first()
    const $rect = $('#departureCalendar_animationWrapper')

    // setDateToForm()で使用する。非同期処理だとeventがなくなってしまう
    const eventTarget = event.currentTarget

    // カレンダーのマスの位置に移動
    $rect.css({
      'position': 'absolute',
      'top': $from.offset().top - this.$el.offset().top,
      'left': $from.offset().left - this.$el.offset().left,
      'height': $from.height(),
      'width': $from.width()
    })

    // transitionを付与
    $rect.addClass('-animated')

    // 赤い四角を表示
    $rect.addClass('-invoked')
    await this.waitTransitionEnd()

    // 日付入力欄の位置に移動
    $rect.css({
      'position': 'absolute',
      'top': $to.offset().top - this.$el.offset().top,
      'left': $to.offset().left - this.$el.offset().left,
      'height': $to.outerHeight(),
      'width': $to.outerWidth()
    })
    await this.waitTransitionEnd()

    // 余韻
    const afterglow = 400
    await this.wait(afterglow)

    // 消す
    $rect.removeClass('-invoked')
    await this.waitTransitionEnd()

    // transitionを外す
    $rect.removeClass('-animated')

    // 元の位置に戻す
    $rect.css({'position': '', 'top': '', 'left': '', 'height': '', 'width': ''})

    this.setDateToForm(eventTarget.dataset.year, eventTarget.dataset.month, eventTarget.dataset.date)
  }

  waitTransitionEnd() {
    const transitionMilliSeconds = 400

    return this.wait(transitionMilliSeconds)
  }

  wait(millisecond) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved')
      }, millisecond)
    })
  }

  // can access this.el or this.$el
  mounted() {
    const self = this
    this.contentList = []
    this.$el.find(".departureCalendar_calendarMonth").each(function(){
      self.contentList.push($(this))
    })

    // ページ表示時点の表示カレンダーを覚える
    this.contentList.forEach(($elm, index) => {
      if ($elm.hasClass("-active")) {
        this.$data.activeIndex = index
      }
    })

    // 先月、次月へのリンクを設定する
    this.contentList.forEach(($elm, index) => {
      $elm.find(".calendar_previousMonthButton").on("click", () => {
        this.$data.activeIndex = index - 1
        return false
      })
      $elm.find(".calendar_nextMonthButton").on("click", () => {
        this.$data.activeIndex = index + 1
        return false
      })
    })

    // 日付をクリックしたときのイベントを設定する
    this.el.querySelectorAll(".departureCalender_monthTable .price").forEach((priceTag) => {
      priceTag.addEventListener("click", (e) => {
        this.selectDepartureDate(e).catch((e) => { console.error('rejected', e.reason, e)} )
        e.preventDefault()
      })
    })
  }
}

// export as singleton
const instance = new DepartureCalendar("#departureCalendar")
// Object.seal(instance)
export default instance
